export default __webpack_public_path__ + "static/avatar-group-dark-1fbad250087004944911d6c81c942701.png";